import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormLabel,
  TextField,
  Alert,
  Autocomplete,
  IconButton,
} from "@mui/material";
import { CloudUpload, Delete, Send } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import { exportCustomerAsCsv, exportCustomerAsExcel, fetchCustomers, importCustomers } from "../../redux/Slice/customerSlice";

const ExportCustomer = () => {

const { customers } = useSelector((state)=> state.customer);
  const message = useSelector((state) => state.message);

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadError, setUploadError] = useState("");
  const [exportFilters, setExportFilters] = useState({
    industry: "",
    fileType: "",
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const handleFilterChange = (e) => {
    setExportFilters({ ...exportFilters, [e.target.name]: e.target.value });
  };

  const downloadFile = (blobData, fileType) => {
    const fileExtension = fileType === "csv" ? "csv" : "xlsx"; 
    const mimeType =
      fileType === "csv"
        ? "text/csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  
    const fileBlob = new Blob([blobData], { type: mimeType });
  
    const fileUrl = window.URL.createObjectURL(fileBlob);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `customers.${fileExtension}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(fileUrl);
  };
  
  const exportCustomers = async () => {
    try {
      dispatch(setLoading(true));
      const params = {
        industry: exportFilters.industry,
        // customer_type: exportFilters.customer_type,
      };
  
      let response;
      if (exportFilters.fileType === "csv") {
        response = await dispatch(exportCustomerAsCsv(params)).unwrap();
      } else if (exportFilters.fileType === "excel") {
        response = await dispatch(exportCustomerAsExcel(params)).unwrap();
      }
  
      if (response) {
        const blobData = new Blob([response], {
          type: exportFilters.fileType === "csv" ? "text/csv" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
  
        downloadFile(blobData, exportFilters.fileType);
      } else {
        setUploadError("Failed to export customers. Please try again.");
      }
    } catch (error) {
      console.error("Error exporting customers:", error);
      setUploadError("Failed to export customers. Please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  const importCustomer = async () => {
    if (!selectedFile) return;
  
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("file", selectedFile);
  
      await dispatch(importCustomers(formData)).unwrap(); 
      setSelectedFile(null); 
    } catch (error) {
      console.error("Error importing customers:", error);
      setUploadError("Failed to import customers. Please try again.");
    } finally {
      dispatch(setLoading(false)); 
    }
  };
  



const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  const validTypes = ["text/csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
  if (!validTypes.includes(file.type)) {
    setUploadError("Invalid file type. Please upload a CSV or Excel file.");
    return;
  }

  setUploadError("");
  setSelectedFile(file);
};

const handleDrop = (event) => {
  event.preventDefault();
  const file = event.dataTransfer.files[0];

  if (!file) return;
  handleFileChange({ target: { files: [file] } });
};

const removeFile = () => {
  setSelectedFile(null);
  // Enable the file input after file removal to allow re-upload
  document.getElementById("fileUpload").value = "";
};


  
const resetFilters = () => {
  setExportFilters({
    industry: "",
    // customer_type: "",
    // assignedEmployee: "",
    fileType: "",
  });
};


return (
<div className="content">
  <Typography variant="h4" gutterBottom>
    Import and Export Customer
  </Typography>

  <Grid container spacing={3} sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2 ,mt:1}}>
    {/*Import Customers */}
    <Grid item xs={12} md={6}>
    <Box sx={{ border: "1px solid #ddd", p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 , color: "#3f51b5"}}>
        Import Customer
      </Typography>
      <Grid container justifyContent="center">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            padding: 3,
            border: "2px dashed #ccc",
            borderRadius: "12px",
            position: "relative",
            backgroundColor: "#f9f9f9",
            width: 350,
            height: 130, 
            "&:hover": {
              borderColor: "#3f51b5",
              backgroundColor: "#f3f3ff",
            },
          }}
          onDragOver={(e) => e.preventDefault()}
          onDrop={handleDrop}
        >
          <input
            type="file"
            hidden
            id="fileUpload"
            onChange={handleFileChange}
            accept=".csv, .xls, .xlsx"
          />

          {!selectedFile ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
                cursor: "pointer",
              }}
              component="label"
              htmlFor="fileUpload"
            >
              <CloudUpload fontSize="large" sx={{ color: "#3f51b5" }} />
              <Typography variant="h6" sx={{ textAlign: "center", color: "#3f51b5" }}>
                Click here to upload
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#777", fontStyle: "italic", textAlign: "center" }}
              >
               Drag & Drop or Click to Upload <br /> Accepted formats: .csv, .xls, .xlsx
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                width: "70%", 
                height: "50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                border: "2px dashed #ccc",
                borderRadius: "12px",
                padding: 3,
                backgroundColor: "#f9f9f9",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                transition: "0.3s ease-in-out",
                "&:hover": {
                  border: "2px solid #3f51b5",
                  backgroundColor: "#f3f3ff",
                },
              }}
            >
              <IconButton
                onClick={removeFile}
                sx={{
                  position: "absolute",
                  top: -12,
                  right: -12,
                  backgroundColor: "#ff9999",
                  color: "#fff",
                  width: 32,
                  height: 32,
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
                  "&:hover": {
                    backgroundColor: "#ff3333",
                  },
                }}
              >
                <Delete fontSize="small" />
              </IconButton>

              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mt: 2, textAlign: "center" }}
              >
                Selected File:{" "}
                <Box component="span" sx={{ color: "#3f51b5", fontWeight: "bold" }}>
                  {selectedFile.name}
                </Box>
              </Typography>

              <IconButton
                onClick={importCustomer}
                sx={{
                  position: "absolute",
                  bottom: -15,
                  right: 12,
                  backgroundColor: "#7986cb",
                  color: "#fff",
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  transition: "0.3s",
                  "&:hover": {
                    backgroundColor: "#2c387e",
                  },
                }}
              >
                <Send fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>
        {uploadError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {uploadError}
          </Alert>
        )}
      </Grid>
      </Box>
    </Grid>

    <Grid item xs={12} md={6}>
      <Box sx={{ border: "1px solid #ddd", p: 3, borderRadius: 2, boxShadow: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, color: "#3f51b5" }}>
          Export Customer
        </Typography>

        <Grid container spacing={3} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ width: '100%' }}>
  {/* Export Filters Section - First Row */}
  <Grid container spacing={3} sx={{ width: '100%' }}>
    <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="fileType-filter">
          File Type <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <Select
          id="fileType"
          name="fileType"
          value={exportFilters.fileType}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="csv">CSV</MenuItem>
          <MenuItem value="excel">Excel</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="industry-filter">Industry</FormLabel>
        <Select
          id="industry-filter"
          name="industry"
          value={exportFilters.industry}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="construction">Construction</MenuItem>
          <MenuItem value="IT">IT</MenuItem>
          <MenuItem value="healthcare">Healthcare</MenuItem>
          <MenuItem value="manufacturing">Manufacturing</MenuItem>
          <MenuItem value="other">Other</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  </Grid>

  {/* Export Filters Section - Second Row */}
  {/* <Grid container spacing={2} sx={{ width: '100%' }}> */}
    {/* <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="customer_type-filter">Customer Type</FormLabel>
        <Select
          id="customer_type-filter"
          name="customer_type"
          value={exportFilters.customer_type}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="hot">New Customer</MenuItem>
          <MenuItem value="warm">Converted from Lead</MenuItem>
          <MenuItem value="cold">Cold</MenuItem>
        </Select>
      </FormControl>
    </Grid> */}

    {/* <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="businessSize-filter">Business Size</FormLabel>
        <Select
          id="businessSize-filter"
          name="businessSize"
          value={exportFilters.businessSize}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="small">Small</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="large">Large</MenuItem>
        </Select>
      </FormControl>
    </Grid> */}
  {/* </Grid> */}

    {/* Export Filters Section - Third Row */}
    {/* <Grid container spacing={2} sx={{ width: '100%' }}>
    <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="enquiryType-filter">Enquiry Type</FormLabel>
        <Select
          id="enquiryType-filter"
          name="enquiryType"
          value={exportFilters.enquiryType}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="hot">Hot</MenuItem>
          <MenuItem value="warm">Warm</MenuItem>
          <MenuItem value="cold">Cold</MenuItem>
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} md={6} sx={{ width: '48%' }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel htmlFor="businessSize-filter">Business Size</FormLabel>
        <Select
          id="businessSize-filter"
          name="businessSize"
          value={exportFilters.businessSize}
          onChange={handleFilterChange}
          variant="outlined"
          sx={{
            borderRadius: "8px",
            "&:hover": { borderColor: "#3f51b5" },
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="small">Small</MenuItem>
          <MenuItem value="medium">Medium</MenuItem>
          <MenuItem value="large">Large</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  </Grid> */}

  
         
         {/* Button */}
           <Grid container spacing={3} sx={{ width: '100%', mb: 2, gap: 3,mr:2, display: "flex",  justifyContent: "flex-end",}}>
         {/* Reset Button */}
           <Grid item xs={12} md={6}>
             <Button
               variant="outlined"
               onClick={resetFilters}
               fullWidth
             >
               Reset
             </Button>
           </Grid>
         
           {/* Export Button */}
           <Grid item xs={12} md={6}>
             <Button
               variant="outlined"
               sx={{
                 color: "#3f51b5",
                 borderColor: "#3f51b5",
                 "&:hover": {
                   backgroundColor: "#3f51b5",
                   color: "#fff",
                 },
               }}
               onClick={exportCustomers}
               fullWidth
               disabled={!exportFilters.fileType}
             >
               Export Customers
             </Button>
           </Grid>
         </Grid>
         
        </Grid>
      </Box>
    </Grid>
  </Grid>
</div>
);

};

export default ExportCustomer;
